import styled from 'styled-components'
import { Typography, Input, Checkbox, Select } from 'antd'

const { Text } = Typography

export const PharmacyNotesContainer = styled.div`
    grid-column: 1 / 3;
    display: flex;
    flex-direction: column;
    gap: 10px;
`

export const NotesRow = styled.div`
    display: flex;
    gap: 10px;
`

export const NotesLabel = styled.div`
    color: rgba(0, 0, 0, 0.65);
    font-weight: 400;
    text-transform: capitalize;
    white-space: nowrap;
`

export const VariablesCard = styled.div`
    background: #fafbfc;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const VariablesCardHint = styled(Text)`
    color: rgba(0, 0, 0, 0.65);
    font-size: 0.85rem;
    font-weight: bold;
`

export const VariableRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`

export const VariableLabel = styled(Text)`
    min-width: 140px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 0.9rem;
    font-weight: bold;
    text-transform: none;
`

export const FilledToken = styled.span`
    color: #52c41a;
`

export const UnfilledToken = styled.span`
    color: #ff4d4f;
    background: #fff1f0;
    padding: 0 3px;
    border-radius: 2px;
`

export const PreviewText = styled(Text)`
    text-transform: none;
    font-weight: bold;
`

export const CompoundIngredientRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    text-transform: capitalize;
`

export const ScheduleIndicator = styled.span`
    color: red;
`

export const PrescriptionContainer = styled.div`
    padding: 0 50px;
`

export const MedicationHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const MedicationTitle = styled(Text)`
    font-size: 1.05rem;
    font-weight: bolder;
`

export const UnresolvedWarning = styled(Text)`
    color: #ff4d4f;
    font-size: 0.8rem;
`

export const PrescriptionGrid = styled.div`
    margin-top: 30px;
    display: grid;
    grid-template-columns: 65% 35%;
    row-gap: 10px;
`

export const ReadyToSignBox = styled.div`
    justify-self: center;
    width: 150px;
    padding: 10px;
    font-weight: bold;
    background: rgba(123, 173, 126, 0.15);
`

export const SignCheckbox = styled(Checkbox)`
    && {
        margin-left: 5px;
    }
`

export const VariableInput = styled(Input)`
    max-width: 300px;
`

export const VariableSelect = styled(Select)`
    flex: 1;
    min-width: 0;
`
